import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3" }

import { computed, watch } from 'vue';
    import { Input } from '@/components/ui/input';
    import { InputRow, Combobox, Select } from '@/components/ui/form';
    import { optionsYesNo } from '@/utils/form';
    import { useI18n } from 'vue-i18n';
    import { usePage } from '@inertiajs/vue3';
    import { useUserData } from '@/composables/useUserData';
    import type { SharedData, User, Employee } from '@/types';
    import { Alert } from '@/components/ui/alert';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeUserForm',
  props: {
    form: {},
    employee: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

    const page = usePage<SharedData>();
    const selectedCompanyId = computed(() => page.props.auth.user.selected_company_id);

    const { users, isPlaceholderDataUsers } = useUserData(selectedCompanyId.value);

    const userOptions = computed(() => {
        return users.value.map((user: User) => ({
            ...user,
            label: `${user.name} (${user.email})`,
            addon: user.employee_id ? t('employee.user.assigned_employee') : null,
            disabled: !!user.employee_id,
        }));
    });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.employee?.user_id)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 0,
          form: _ctx.form,
          name: "create_user",
          label: "employee.user.create_user"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Select), {
              modelValue: _ctx.form.user.create_user,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.user.create_user) = $event)),
              options: _unref(optionsYesNo),
              translate: true
            }, null, 8, ["modelValue", "options"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.form.user.create_user === 0)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 1,
          form: _ctx.form,
          name: "user_id",
          label: "employee.user.id",
          "error-key": "user.id"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Combobox), {
              id: "user_id",
              modelValue: _ctx.form.user.id,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.user.id) = $event)),
              options: userOptions.value,
              "value-by": "id",
              placeholder: _unref(t)('employee.user.id'),
              loading: _unref(isPlaceholderDataUsers),
              disabled: !!_ctx.employee?.user_id
            }, null, 8, ["modelValue", "options", "placeholder", "loading", "disabled"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.form.user.create_user === 1)
      ? (_openBlock(), _createBlock(_unref(Alert), {
          key: 2,
          variant: "info"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('employee.user.create_info')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})